import Icon from '../components/Icon.vue'

Icon.register({
  map: {
    width: 576,
    height: 512,
    paths: [
      {
        d: 'M0 117.7V464C0 475.3 11.4 483 21.9 478.8L160 416V32L20.1 87.9A32-32 0 0 1 0 117.7zM192 416L384 480V96L192 32V416zM554.1 33.2L416 96V480L555.9 424.1A32-32 0 0 1 576 394.3V48C576 36.7 564.6 29 554.1 33.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/map.js
// module id = 3fLA
// module chunks = 144